module.exports = __webpack_public_path__ + "img/dianliang3.4414c776.png";